import React from 'react';

const DashboardHome = () => {
    return (
        <div className="mt-5" >
            <h1>Welcome To Dashboard</h1>
        </div>
    );
};

export default DashboardHome;